module.exports = __webpack_public_path__ + "img/br21.9346a6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br21.jpg
// module id = 1wn3
// module chunks = 0